// Assuming `baseUrl` and `cacheMode` are still needed as before.
const baseUrl = process.env.REACT_APP_ASSETS_BASE_URL;
const cacheMode = "default";

const assets = (businessSlug, version) => {
  return {
    logo: () =>
      gen([baseUrl, businessSlug], ["logo"], 300, 300, cacheMode, version),
    stampCard: (schemeSlug, isPositional = false) => {
      return {
        background: {
          scheme: () =>
            gen(
              [baseUrl, businessSlug, schemeSlug],
              ["background"],
              282,
              470,
              cacheMode,
              version
            ),
          template: (templateName) =>
            gen(
              [baseUrl, businessSlug, schemeSlug],
              [`background-template-${templateName}`],
              282,
              470,
              cacheMode,
              version
            ),
          layout: (layoutName) =>
            gen(
              [baseUrl, businessSlug, schemeSlug],
              [`background-layout-${layoutName}`],
              282,
              470,
              cacheMode,
              version
            ),
          progressCard: (cardNumber) =>
            gen(
              [baseUrl, businessSlug, schemeSlug],
              [`background-card-${cardNumber}`],
              282,
              470,
              cacheMode,
              version
            ),
          progressStamp: (numberOfStamps) =>
            gen(
              [baseUrl, businessSlug, schemeSlug],
              [`background-stamp-${numberOfStamps}`],
              282,
              470,
              cacheMode,
              version
            ),
          rewardPresence: (presence) =>
            gen(
              [baseUrl, businessSlug, schemeSlug],
              [presence ? "background-reward" : "background-no-reward"],
              282,
              470,
              cacheMode,
              version
            ),
          rewardType: (rewardType) =>
            gen(
              [baseUrl, businessSlug, schemeSlug],
              [`background-reward-${rewardType}`],
              282,
              470,
              cacheMode,
              version
            ),
        },
        inking: (rewardType) =>
          genMulti(
            [baseUrl, businessSlug, schemeSlug, rewardType],
            ["inking"],
            100,
            100,
            cacheMode,
            version,
            isPositional
          ),
        target: (rewardType) =>
          genMulti(
            [baseUrl, businessSlug, schemeSlug, rewardType],
            ["target"],
            100,
            100,
            cacheMode,
            version,
            isPositional
          ),
        inkingBig: (rewardType) =>
          genMulti(
            [baseUrl, businessSlug, schemeSlug, rewardType],
            ["inking", "big"],
            300,
            100,
            cacheMode,
            version,
            isPositional
          ),
        targetBig: (rewardType) =>
          genMulti(
            [baseUrl, businessSlug, schemeSlug, rewardType],
            ["target", "big"],
            300,
            100,
            cacheMode,
            version,
            isPositional
          ),
        confirmation: (rewardType) =>
          gen(
            [baseUrl, businessSlug, schemeSlug, rewardType],
            ["confirmation"],
            280,
            223,
            cacheMode,
            version
          ),
        logo: () =>
          gen(
            [baseUrl, businessSlug, schemeSlug],
            ["logo"],
            300,
            300,
            cacheMode,
            version
          ),
        custom: (name, width, height) =>
          gen(
            [baseUrl, businessSlug, schemeSlug, "custom"],
            [name],
            width,
            height,
            cacheMode,
            version
          ),
      };
    },
    vouchers: (schemeSlug) => {
      return {
        active: (rewardType) =>
          gen(
            [baseUrl, businessSlug, schemeSlug, rewardType],
            ["active"],
            186,
            186,
            cacheMode,
            version
          ),
        inactive: (rewardType) =>
          gen(
            [baseUrl, businessSlug, schemeSlug, rewardType],
            ["inactive"],
            186,
            186,
            cacheMode,
            version
          ),
        thumbnail: (rewardType) =>
          gen(
            [baseUrl, businessSlug, schemeSlug, rewardType],
            ["thumbnail"],
            74,
            74,
            cacheMode,
            version
          ),
        confirmation: (rewardType) =>
          gen(
            [baseUrl, businessSlug, schemeSlug, rewardType],
            ["confirmation"],
            280,
            223,
            cacheMode,
            version
          ),
      };
    },
    custom: (name, width, height) =>
      gen(
        [baseUrl, businessSlug, "custom"],
        [name],
        width,
        height,
        cacheMode,
        version
      ),
  };
};

const subscriptions = (templateUrn, version) => {
  return {
    thumbnail: () =>
      gen(
        [baseUrl, "_subscriptions", templateUrn],
        ["thumbnail"],
        74,
        74,
        cacheMode,
        version
      ),
    hero: () =>
      gen(
        [baseUrl, "_subscriptions", templateUrn],
        ["hero"],
        280,
        223,
        cacheMode,
        version
      ),
    perk: (perkSlug) => {
      return {
        thumbnail: () =>
          gen(
            [baseUrl, "_subscriptions", templateUrn, perkSlug],
            ["thumbnail"],
            74,
            74,
            cacheMode,
            version
          ),
        active: () =>
          gen(
            [baseUrl, "_subscriptions", templateUrn, perkSlug],
            ["active"],
            186,
            186,
            cacheMode,
            version
          ),
        inactive: () =>
          gen(
            [baseUrl, "_subscriptions", templateUrn, perkSlug],
            ["inactive"],
            186,
            186,
            cacheMode,
            version
          ),
        confirmation: () =>
          gen(
            [baseUrl, "_subscriptions", templateUrn, perkSlug],
            ["confirmation"],
            280,
            223,
            cacheMode,
            version
          ),
      };
    },
  };
};

function genMulti(
  pathParts,
  fileParts,
  width,
  height,
  cache = "force-cache",
  version,
  isPositional = false
) {
  const positionalSupport = pathParts.some((p) => p === "default");
  if (positionalSupport && isPositional) {
    return Array.from({ length: 99 }, (_v, i) =>
      gen(pathParts, fileParts, width, height, cache, version, i + 1)
    );
  } else {
    return gen(pathParts, fileParts, width, height, cache, version, -1);
  }
}

function gen(
  pathParts,
  fileParts,
  width,
  height,
  cache = "force-cache",
  version,
  position = -1
) {
  const filePartsClone = [...fileParts];
  if (position >= 0) {
    filePartsClone.unshift(position + "");
  }

  const path = pathParts.join("/");
  const file = filePartsClone.join("-");
  const versionParam = version ? `?v=${version}` : "";

  // For web, we will simply return a URL as a string
  //   return `${path}/${file}.png${versionParam}`;
  return `${path}/${file}@1x.png`;
}

export { assets, subscriptions };
